/**
 * Quantity Selector Component
 *
 * @package Enterprise\BookingSystem\Blocks
 */

/**
 * WordPress dependencies
 */
import { useDispatch, useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

/**
 * External dependencies
 */
import { QuantityInput } from '@ebs/components';

/**
 * Internal dependencies
 */
import { store as addToCartStore } from '../../../data/add-to-cart';

type QuantitySelectorProps = {
	readonly productId: number;
};

export const QuantitySelector = ({ productId }: QuantitySelectorProps) => {
	const { isDisabled, quantity, validationErrors } = useSelect(
		(select) => {
			const storeSelectors = select(addToCartStore);
			return {
				isDisabled: storeSelectors.isAdding(productId) || storeSelectors.isLoadingVariants(productId),
				quantity: storeSelectors.getQuantity(productId),
				validationErrors: storeSelectors.getValidationErrors(productId),
			};
		},
		[productId],
	);

	const dispatch = useDispatch(addToCartStore);
	const error = validationErrors.quantity;

	return (
		<div className="ebs-add-to-cart__quantity">
			<QuantityInput
				id={`ebs-quantity-${productId}`}
				value={quantity}
				onChange={(newQty: number) => {
					void dispatch.setQuantity(productId, newQty);
				}}
				min={1}
				max={100}
				disabled={isDisabled}
				label={__('Number of Photo Booths', 'enterprise-booking-system')}
				error={error}
				showLabel={false}
				size="medium"
				className="ebs-add-to-cart__quantity-input"
			/>
		</div>
	);
};
